import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaThumbsDown, FaThumbsUp } from 'react-icons/fa6';
import { ToastContext } from './context/ToastContext';
import { number } from 'prop-types';
import '../styles/AnswerVotes.css';

function AnswerVotes({ answerId }) {
    const { sendMessage } = useContext(ToastContext);
    const [loading, setLoading] = useState(false);
    const [votes, setVotes] = useState({
        positive: 0,
        negative: 0,
    });

    const fetchVotes = useCallback(async () => {
        try {
            const url = new URL(`/api/answers/${answerId}/votes`, process.env.APP_URL);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            const { votes, error } = await response.json();
            if (error) {
                sendMessage(error, 'danger');
            }
            if (votes) {
                setVotes(votes);
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        }
    }, [answerId]);

    const vote = async (answerId, isPositive) => {
        try {
            setLoading(true);
            const url = new URL(`/api/answers/${answerId}/votes`, process.env.APP_URL);
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ isPositive }),
            });
            const { success, error } = await response.json();
            if (error) {
                sendMessage(error, 'danger');
            }
            if (success) {
                sendMessage('Vote successful.', 'success');
                await fetchVotes();
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            setLoading(false);
        }
    }; 

    useEffect(() => {
        fetchVotes();
    }, [fetchVotes]);

    return (
        <div
            className={'answer-votes'}
        >
            {votes.positive} <Button
                variant={'light'}
                onClick={() => vote(answerId, true)}
                disabled={loading}
            >
                <FaThumbsUp
                />
            </Button>
            {votes.negative} <Button
                variant={'light'}
                onClick={() => vote(answerId, false)}
                disabled={loading}
            >
                <FaThumbsDown
                />
            </Button>
        </div>
    );
}

AnswerVotes.propTypes = {
    answerId: number,
};

export default AnswerVotes;